// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_modules_faq-assistant_faq-assistant_component_ts":"661fd7a6d50de49b","src_app_shared_layouts_page-not-found_page-not-found_component_ts":"a96289ca5f1af1b2"}[chunkId] + ".js";
};